/**
 * @shelf-version: 1.0.1
 */

import Events from './events';

export default Events;



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/EXT/hannelore/frontend/source/utilities/events/javascript/events/index.js